import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const PAPAUPA_LOGO = '/images/logos/papaupa.jpeg';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          mb: 4,
          background:
            themeMode === 'dark'
              ? 'linear-gradient(135deg, #1a2838 0%, #2d1f3d 40%, #1f2d28 100%)'
              : 'linear-gradient(135deg, #dbeafe 0%, #e9d5ff 35%, #fef3c7 65%, #d1fae5 100%)',
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box sx={{ py: { xs: 3, md: 4 }, px: { xs: 2, md: 3 } }}>
          <Container
            sx={{
              backgroundImage:
                themeMode === 'dark'
                  ? 'url(/images/logos/logo_white.PNG)'
                  : 'url(/images/logos/logo_tnonetwork_black.png)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              height: '12vh',
              mb: 2,
            }}
          />
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 1.2 }}
            variant="overline"
            align="center"
            display="block"
            color="primary"
            gutterBottom
          >
            Propuesta multi-programa
          </Typography>
          <Typography
            variant="h3"
            component="h1"
            fontWeight={800}
            align="center"
            color={theme.palette.primary.dark || theme.palette.primary.main}
            gutterBottom
          >
            Papaupa × TNO Network
          </Typography>
          <Typography
            variant="h5"
            component="p"
            align="center"
            sx={{
              fontStyle: 'italic',
              fontWeight: 600,
              maxWidth: 640,
              mx: 'auto',
              mb: 3,
              color: theme.palette.text.primary,
            }}
          >
            «Un pedacito de cielo en cada etapa de tu vida»
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Box
              component="img"
              src={PAPAUPA_LOGO}
              alt="Papaupa"
              sx={{
                maxWidth: 200,
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                bgcolor: '#fff',
                borderRadius: 2,
                p: 1.5,
                boxShadow: theme.shadows[4],
              }}
            />
          </Box>
          <Box
            sx={{
              maxWidth: 760,
              mx: 'auto',
              py: 2,
              px: 2,
              borderRadius: 2,
              bgcolor:
                theme.palette.mode === 'dark'
                  ? 'rgba(255,255,255,0.06)'
                  : 'rgba(255,255,255,0.75)',
            }}
          >
            <Typography variant="body1" color="textSecondary" align="center" sx={{ lineHeight: 1.8 }}>
              Potencia <strong>audiovisual y digital directa</strong>: la marca se ve, se escucha y se siente en
              cada rincón de la programación. Invasión de marca orgánica en{' '}
              <strong>Punto de Fe</strong>, <strong>Somos Padres</strong> y <strong>2do Escalón</strong>, con foco
              en pantalla, radio, menciones y redes.
            </Typography>
          </Box>
          <Box
            sx={{
              maxWidth: 520,
              mx: 'auto',
              mt: 2.5,
              py: 1.25,
              px: 2,
              borderRadius: 2,
              border: `2px solid ${theme.palette.secondary.main}`,
              bgcolor: theme.palette.secondary.light + '55',
              textAlign: 'center',
            }}
          >
            <Typography variant="body1" fontWeight={700} color="secondary.dark">
              Plan de Dominio Multi-Pantalla — $300 USD/mes
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
